import { render } from "./CollapseMenu.vue?vue&type=template&id=72beacf6"
import script from "./CollapseMenu.vue?vue&type=script&lang=js"
export * from "./CollapseMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/CollapseMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72beacf6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72beacf6', __exports__)) {
    api.reload('72beacf6', __exports__)
  }
  
  module.hot.accept("./CollapseMenu.vue?vue&type=template&id=72beacf6", () => {
    api.rerender('72beacf6', render)
  })

}


export default __exports__